import ToggleButton from 'components/base/ToggleButton';

import { ApiNftMarketAvailability } from 'gql/api/types-api.generated';

import { MarketAvailability } from 'types/MarketAvailability';
import { NftFilters } from 'types/Nft';

type MarketAvailabilityVariant = 'all' | 'world';

type MarketAvailabilityFilterProps = {
  filters: NftFilters;
  setMarketAvailability: (marketAvailability: ApiNftMarketAvailability) => void;
};

export default function MarketAvailabilityFilter(
  props: MarketAvailabilityFilterProps
) {
  const { filters, setMarketAvailability } = props;

  const filterOptions = variantFilterMap.all;

  return (
    <>
      {filterOptions.map((availabilityMode) => {
        return (
          <ToggleButton
            key={availabilityMode.value}
            size={0}
            type="button"
            variant="outline"
            pressed={filters?.marketAvailability === availabilityMode.value}
            onClick={() => {
              setMarketAvailability(availabilityMode.value);
            }}
          >
            {availabilityMode.label}
          </ToggleButton>
        );
      })}
    </>
  );
}

type Filter = {
  value: MarketAvailability;
  label: string;
};

export const LIVE_AUCTION_FILTER = {
  value: 'LIVE_AUCTION' as const,
  label: 'Live auction',
};

export const BUY_NOW_FILTER = {
  value: 'HAS_ACTIVE_BUY_NOW' as const,
  label: 'Buy now',
};

export const RESERVE_FILTER = {
  value: 'RESERVE_NOT_MET' as const,
  label: 'Reserve',
};

export const OFFER_FILTER = {
  value: 'HAS_ACTIVE_OFFER' as const,
  label: 'Offer',
};

// TODO: simplify filters since there's no difference b/w all & worlds
const variantFilterMap: Record<MarketAvailabilityVariant, Filter[]> = {
  all: [LIVE_AUCTION_FILTER, BUY_NOW_FILTER, RESERVE_FILTER],
  world: [LIVE_AUCTION_FILTER, BUY_NOW_FILTER, RESERVE_FILTER],
};
